export enum ProjectRole {
  member = 'member',
  admin = 'admin',
}
